import axiosInst from "@/plugins/axios";
// import { isAxiosError } from "axios";
import { defineStore } from "pinia";
import SessionStorage from 'quasar/src/plugins/SessionStorage.js';;
import { useBillStore } from "./BillStore";
import { BigAlert, simpleError } from "@/plugins/notify/notify";

//store//
export const useSessionStore = defineStore("session", {
  actions: {
    async createNewSession() {
      await axiosInst()
        .get("session")
        .then(({ data }) => {
          if (data?.result === "success" && data?.data) {
            SessionStorage.set("token", data.data);

            axiosInst().post("session", [
              {
                externalId: window.onlExternalId || "",
                onlSessionData: {},
                onlSessionType: "BILL",
              },
            ]);
          } else {
            console.error(data);
            simpleError();
          }
        })
        .catch((e) => {
          console.error(e);
          simpleError();
        });
    },

    // eslint-disable-next-line
    callBack(action: string, data: any) {
      if (window.onlCallback) {
        console.log(typeof window.onlCallback);

        const session = SessionStorage.getItem("token");
        try {
          setTimeout(window.onlCallback(session, action, data), 0);
        } catch (e) {
          console.error("onlCallback error", e);
        }
      }
    },

    timeoutError() {
      BigAlert({
        type: "warning",
        title: "Время сессии истекло!",
      });

      SessionStorage.remove("token");
      useBillStore().$reset();
    },
  },

  getters: {
    baseUrl: () => {
      return window.onlBaseURL;
    },
  },
});

//types

declare global {
  interface Window {
    onlExternalId?: string;
    onlBillPayments?: string[];
    onlDivision?: string;
    onlBillTheme?: TypeBillTheme;
    onlBaseURL?: string;
    onlAPIKey?: string;

    // eslint-disable-next-line
    onlCallback?: any;
  }
}

type TypeBillTheme = {
  primary?: string;
  background?: string;
  negative?: string;
};
